module.exports = __webpack_public_path__ + "3d865e5fa4864391892da3974c2d14f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/venn_content_commerce_mobile.png
// module id = 221
// module chunks = 0